import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { Platform } from 'ionic-angular';
import { EzoomApiProvider } from './ezoom-api';
import { GlobalProvider } from './global';

@Injectable()
export class UserProvider {
    user: any = false;

    private _storageReady:boolean = false;
    firebasePlugin;
    constructor(
        public api: EzoomApiProvider,
        private storage: Storage,
        private global: GlobalProvider,
        private platform: Platform
    ) {
        this.firebasePlugin = (<any>window).FirebasePlugin;

        this.storage.ready().then(() => {
            this._storageReady = true;
            if(this.platform.is('core')){
                Promise.all([
                    this.get('id'),
                    this.storage.get('dateAccess')
                ]).then((data:any) =>{
                    if ((Date.now() - data[1]) > 600000 &&  data[0] != '224107'){
                        this.logout();
                    }
                    else{
                        this.storage.set('dateAccess', Date.now());
                    }
                })
            }
        });
    }

    public get(key:any = false) {
        return new Promise(resolve => {
            if (key == 'deviceId'){
                this.storage.get('deviceId').then(id => {
                    if (id != null){
                        resolve(id);
                    }
                    resolve(false);
                });
            }else{
                this.storage.get('user').then(data => {
                    if (data != null){
                        resolve(key !== false ? data[key] : data);
                    }
                    resolve(false);
                });
            }
        });
    }

    public getPhones() {
        return new Promise((resolve, reject) => {
            this.api.get('user/phones').subscribe((response:any) => {
                if (response.status){
                    resolve(response.data);
                }else{
                    reject(response.data);
                }
            });
        });
    }

    public getVaccinated() {
        return new Promise((resolve, reject) => {
            this.api.get('user/vaccinated').subscribe((response:any) => {
                if (response.status){
                    resolve(response.data);
                }else{
                    resolve(false);
                }
            });
        });
    }

    public deleteComprovante(imageURL){
        return new Promise((resolve, reject) => {
            this.api.get('user/delete-comprovante', {image: imageURL}).subscribe((response:any) => {
                if (response.status){
                    resolve(response.data);
                }else{
                    reject(response.data);
                }
            });
        });
    }

    public getPractices(type) {
        return new Promise((resolve, reject) => {
            this.api.get('practices', { type: type }).subscribe((response: any) => {
                if (response.status) {
                    resolve(response.data);
                } else {
                    reject(response.data);
                }
            });
        });
    }

    public checkStudent() {
        return new Promise((resolve, reject) => {
            this.api.get('user/check_student').subscribe((response:any) => {
                if (response.status){
                    resolve(response.data);
                }else{
                    reject(response.data);
                }
            });
        });
    }

    public getTimeoutMapa() {
        return new Promise((resolve, reject) => {
            this.api.get('api_controller/get_timeout_mapa').subscribe((response:any) => {
                console.log(response);
                if (response.status){
                    resolve(response.data);
                }
                else
                {
                    reject(response.data);
                }
            });
        });
    }

    public updateAccount(data:any) {
        return new Promise((resolve, reject) => {
            this.api.post('user/edit', data).subscribe((response:any) => {
                if (response.status){
                    this.get('sequency').then(sequency => {
                        if (sequency == data.sequency){
                            // this._loggedIn();
                        }
                    });
                    resolve(response.data);
                }else{
                    reject(response.data);
                }
            });
        });
    }

    public sendIframeError(data:any) {
        return new Promise((resolve, reject) => {
            this.api.post('user/iframe_error_mail', data).subscribe((response:any) => {
                if (response.status){
                    resolve(response.data);
                }else{
                    reject(response.data);
                }
            });
        });
    }

    public updateDeviceId(id, update:boolean = false) {
        this.storage.set('deviceId', id);
        if (update) {
          this.api.post('user/update-udid', {udid: id});
        }
    }

    public checkDocument(cpf) {
        return new Promise((resolve, reject) => {
            this.api.get('user/check-document', {cpf: cpf}).subscribe((response: any) => {
                resolve(response.data.member);
            });
        });
    }

    public login(data:any) {
        return new Promise((resolve, reject) => {
            this.api.get('user/login', data).subscribe((response:any) => {
                if (response.status){
                    this._loggedIn(response.data);
                    resolve(response);
                }else{
                    reject(response.data);
                }
            });
        });
    }

    public changePassword(data:any) {
        return new Promise((resolve, reject) => {
            this.api.post('retrieve-password/change-password', data).subscribe((response:any) => {
                if (response.status){
                    this._loggedIn(response.data);
                    resolve(response);
                }else{
                    reject(response.data);
                }
            });
        });
    }

    public forgot(data:any) {
        return new Promise((resolve, reject) => {
            this.api.get('retrieve-password', data).subscribe((response:any) => {
                if (response.status){
                    resolve(response.data);
                }else{
                    reject(response.data);
                }
            });
        });
    }

    public async authenticated() {
        return await this.storage.get('user');
    }

    public checkHash(hash:String) {
        return new Promise((resolve) => {
            this.api.get('retrieve-password/check-hash', {hash: hash}).subscribe((response:any) => {
                resolve(response);
            });
        });
    }

    /**
    * Log the user out, which forgets the session
    */
    public logout() {
        this.storage.remove('user').then(()=>{
            this.global.isLogged(false);
            this.global.updateUserData(null);
        });
    }

    /**
    * Process a login/signup response to store user data
    */
    private _loggedIn(data) {
        this.storage.set('user', data);
        this.storage.set('dateAccess', Date.now());
        this.global.isLogged(true);
        this.global.updateUserData(data);

        if (this.platform.is('cordova')){
            this.storage.get('deviceId').then(udid => {
                this.firebasePlugin.setUserProperty('level', data.level);
            });
        }
    }

    /**
    * set read notification, NOT WORKING
    */
    public readFromPush (sendID: any, notificationID: any) {
        return new Promise(resolve => {
            this.api.post('notifications/readFromPush', {
                id_send: sendID,
                id_notification: notificationID,
            }).subscribe( data => {
                resolve(data);
            });
        });
    }

    /**
    * set read campaign notification
    */
    public readFromCampaignPush (sendID: any, pushId: any) {
        return new Promise((resolve) => {
            this.api.post('notifications/read-campaign', {
                id_send: sendID,
                id_push: pushId,
            }).subscribe( data => {
                resolve(data);
            });
        });
    }

    public verify(key, userResponse) {
        return new Promise((resolve, reject) => {
            this.api.post('user/verify', {secret: key, response: userResponse}).subscribe((response: any) => {
                if (response.success) {
                    resolve(response);
                } else {
                    reject(response);
                }
            });
        });
    }

    public getTrackPermissionTime() {
        return new Promise((resolve, reject) => {
            this.storage.get('trackTime').then(trackTime => {
                resolve(trackTime);
            });
        });
    }

    public setTrackPermissionTime() {
        this.get('id').then(data => {
            let time = new Date().getTime() + ((168 * 3600) * 1000); // no JS ele conta timestamp com milisegundos (x1000)
            this.storage.set('trackTime', time);
        });
    }

    public registerLocation(location: any) {
        return new Promise((resolve, reject) => {
            this.api.post('user/update-location', location).subscribe((response: any) => {
                if (response.status) {
                    resolve(response);
                } else {
                    reject(response);
                }
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/providers/user.ts